import React from "react";

const Home = (props) => {
    return(
    <div className="App">
      <header className="Header">

      <h3> </h3>
      
      <div className="caja_home">
      <img className="imagent1"></img>
      <img className="imagent2"></img>
      <img className="imagent3"></img>
      <img className="imagent4"></img>
      </div>

      </header>
    </div>
  );
}

export {Home}